module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.quoteIsLoaded) ? _c('div', [_c('header', [_c('div', {
    staticClass: "masthead"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('h1', {
    staticClass: "ui header"
  }, [_c('div', {
    staticClass: "sub header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.quoteMeta.job_no))]), _vm._v("\n                |\n                Version: " + _vm._s(_vm.quoteMeta.version) + "\n              ")]), _vm._v("\n              " + _vm._s(_vm.quoteMeta.title) + "\n              "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("\n                " + _vm._s(_vm.quoteMeta.customer) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "six wide right aligned column"
  }, [_c('div', {
    staticClass: "ui tiny grey statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n                " + _vm._s(_vm.quoteAggregates.hours) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                Hours\n              ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui tiny grey statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n                " + _vm._s(_vm.quoteAggregates.pm) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                PM\n              ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui tiny statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n                " + _vm._s(_vm.quoteAggregates.total_hours) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                Total\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui dimmer"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "ui message",
    class: _vm.flash.type
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.clearFlash
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(_vm.flash.type)) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.flash.message))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui top menu"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'summary'
      }
    }
  }, [_vm._v("Summary")]) : _vm._e(), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'editor'
      }
    }
  }, [_vm._v("Editor")]) : _vm._e(), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'fixed_cost_items'
      }
    }
  }, [_vm._v("Fixed Cost Items")]) : _vm._e(), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('div', {
    staticClass: "ui right menu"
  }, [_c('div', {
    staticClass: "item darken-on-hover"
  }, [_vm._v("\n            Last saved: " + _vm._s(_vm.quoteLastSaved) + "\n          ")]), _vm._v(" "), (_vm.quoteHasBeenEdited) ? _c('a', {
    staticClass: "item save-quote",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveQuote($event)
      }
    }
  }, [_vm._v("Save")]) : _c('div', {
    staticClass: "item save-quote"
  }, [_vm._v("Saved")]), _vm._v(" "), _c('div', {
    staticClass: "ui dropdown item",
    attrs: {
      "id": "save-new-version"
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "link item",
    on: {
      "click": _vm.saveNewQuoteVersion
    }
  }, [_vm._v("Save New Version")])])])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tiny grey statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n                +\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tiny grey statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n                =\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1869883c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 219
// module chunks = 2